import i18n from 'i18next';

export default () => [
  {
    title: i18n.t('event-variables'),
    variables: [
      'event_code',
      'start_on',
      'end_on',
      'event_name',
      'primary_instructor',
      'city',
      'primary_location',
      'details',
      'event_external_url',
    ],
  },
  {
    title: i18n.t('enrollment-variables'),
    variables: [
      'enrollment_id',
      'enrollment_type',
      'enrollment_status',
      'enrollment_score',
      'enrollment_due_on',
      'enrollment_completed_on',
      'enrollment_url',
      'enrollment_survery_url',
      'enrollment_assessment_url',
      'enrollment_expires_on',
    ],
  },
  {
    title: i18n.t('activity-variables'),
    variables: ['course_name', 'course_code'],
  },
  {
    title: i18n.t('user-variables'),
    variables: [
      'user_name',
      'first_name',
      'last_name',
      'user_code',
      'user_login',
      'user_email',
      'user_referral_code',
      'user_manager_name',
    ],
  },
  {
    title: i18n.t('user-custom-variables'),
    variables: [
      'user_custom_a',
      'user_custom_b',
      'user_custom_c',
      'user_custom_d',
      'user_custom_e',
      'user_custom_f',
      'user_custom_g',
      'user_custom_h',
      'user_custom_i',
      'user_custom_j',
    ],
  },
];
